// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-9d2ead","sapcnqr-overlay":"sapcnqr-overlay-2108df","sapcnqr-overlay__content":"sapcnqr-overlay__content-6d41bc"};